<div class="flexbox-parent">
    <div fxLayout="row" fxLayoutAlign="center center" style="height: 60vh;  ">
        <div style="text-align:center;">
            <app-zero-image name="task"></app-zero-image><br>
            <h5 class="ma-0">{{'NO_TASKS' | translate}}</h5><br>
            <!--button mat-raised-button color="accent" (click)="create()">{{'ADD Task' | translate}}</button-->
        </div>
    </div>
</div>